<div class="flex justify-content-center flex-direction-column-reverse">
  <ng-container *ngIf="selectedDatasource.type !== 'AMAZONREDSHIFT' && {availableTables : inputAttribute.tableFilterData | filterTablesPipe:{selected: false}:selectedDatasource.type } as tables">
      <cdk-virtual-scroll-viewport itemSize="7" class="example-viewport-3">
        <div *cdkVirtualFor="let pValue of tables.availableTables; let idx = index" class="virtual-scroller-item">
          <div >
            <div class="h5 custom-header-margin"
              *ngIf=" pValue.isDisplayCategory">
              <!-- *ngIf="!pValue.selected && pValue.category != '' && displayCategoryOrNot(inputAttribute, pValue,idx)"> -->
              {{pValue.category}}
            </div>
            <div class="d-flex items-center w-full mt-3 mb-3">
              <div class="d-flex label-02 size-fnt tab-name-1 items-center">
                <span >{{pValue.group}}</span>
                <!-- <span class="iconsvg-question help-icon" #tooltip="matTooltip" *ngIf="['AMAZONSELLER', 'AMAZONSPADS', 'AMAZONSBADS', 'AMAZONSDADS', 'AMAZONDSPADS', 'AMAZONATTRIBUTION'].includes(selectedDatasource.type)"
                  matTooltip="{{pValue.description}}"
                  [matTooltipClass]="{ 'tool-tip': true }"
                  (mouseenter)="$event.stopImmediatePropagation()"
                  (mouseleave)="$event.stopImmediatePropagation()"
                  (click)="tooltip.show()">
                </span> -->
                <mat-icon class="d-flex font-16 ml-2 items-center" *ngIf="pValue?.toolTip && pValue?.toolTip !== undefined && pValue?.toolTip !== ''" aria-hidden="false" [matTooltip]="pValue.toolTip"  aria-label="info" fontIcon="info">info</mat-icon>
                <!-- <span class="material-icons-outlined"> thumb_down </span> -->
                <span class="tooltip hover-tooltip tooltip-sm h-max-content" *ngIf="pValue?.deprecatedTable"  matTooltip="Table has been deprecated" [matTooltipClass]="{ 'tool-tip': true }">
                  <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" class="depricated_icon">thumb_down</mat-icon> -->
                  <img class="full-load in-vertical"
                    src="../../assets/images/new/deprecated.svg" alt="">
                  <!-- <div class="tooltip-section  tooltip-left-0 fade-in m-l-20p">
                    <div class="tooltip-body">
                      Table has been deprecated </div>
                  </div> -->
                </span>
                 <span class="tooltip hover-tooltip tooltip-sm h-max-content" *ngIf="pValue.fullLoadSupported" matTooltip="Data is loaded into warehouse by Full Load method. For more
                  details refer to our documentation"> <img class="full-load "
                    src="../../assets/images/new/full-load.svg" alt="">
                </span>
                <!-- <button mat-icon-button
                  class="icon-btn-sm tooltip hover-tooltip tooltip-sm"  color="primary"> <i
                    class="fas fa-info-circle text-primary"></i>
                    <div class="tooltip-section  tooltip-left-0 fade-in m-l-20p">
                      <div class="tooltip-body">

                        <span [innerHTML]="pValue.description"></span>
                      </div>
                    </div>
                  </button> -->


              </div>
              <span class="ml-auto availableTablesAddButtonContainer" [matTooltip]="addButtonDisableMessageMap.get(pValue.value)?.message" [matTooltipClass]="{ 'tool-tip': true, 'availableTablestooltip': true }">
                <button mat-stroked-button [color]="addButtonDisableMessageMap.get(pValue.value) ? addButtonDisableMessageMap.get(pValue.value).buttonColor : 'primary'"
                  class=" btn-sm syncnow-btn touch-button-add fl-right {{( !(pValue.canSelect) || (pValue.disabled ||  pValue.group.endsWith('_NA')))?'not-allowed-block':''}}"
                  (click)="pValue.selected = true ; onCheckBoxChanged(inputAttribute, pValue, {checked:true}, true, idx)"
                  [disabled]="( pValue.deleted || !(pValue.canSelect) || (pValue.disabled ||  pValue.group.endsWith('_NA'))) || isTemplateAttachedToSource === true ? true : null">
                  <!-- <i  class="icon dripicons-plus f-17p" ></i>  --> <span >+ Add</span>
                </button>
              </span>
            </div>
            <mat-divider *ngIf="!pValue.selected"></mat-divider>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-container>
  <ng-container *ngIf="selectedDatasource.type === 'AMAZONREDSHIFT'">
      <cdk-virtual-scroll-viewport itemSize="50" class="example-viewport-4">
        <div
          *cdkVirtualFor="let pValue of inputAttribute.tableFilterData; let idx = index"
          class="example-item-4">
          <div class="h5 custom-header-margin"
            *ngIf="!pValue.selected && pValue.category != '' && pValue.isDisplayCategory">
            {{pValue.category}}</div>
          <div class="example-item-4 m-r-11" *ngIf="!pValue.selected">
            <div class="label-02 size-fnt tab-name-1 "> {{pValue.group}} <span
                class="tooltip hover-tooltip tooltip-sm"
                *ngIf="pValue?.deprecatedTable"> <img class="full-load in-vertical"
                  src="../../assets/images/new/deprecated.svg" alt="">
                <div class="tooltip-section  tooltip-left-0 fade-in m-l-20p">
                  <div class="tooltip-body"> Table has been deprecated </div>
                </div>
              </span>
              <span class="tooltip hover-tooltip tooltip-sm">
                <img [hidden]="!pValue.fullLoadSupported" class="full-load "
                  src="../../assets/images/new/full-load.svg" alt="">
                <div class="tooltip-section  tooltip-left-0 fade-in m-l-20p">
                  <div class="tooltip-body"> Data is loaded into warehouse by Full Load
                    method.<br> For more details refer to our documentation </div>
                </div>
              </span>
            </div>
              <button mat-stroked-button color="primary"
              class="btn-sm syncnow-btn touch-button-add fl-right {{( !(pValue.canSelect) || (pValue.disabled ||  pValue.group.endsWith('_NA')))?'not-allowed-block':''}}"
              (click)="pValue.selected = true ; onCheckBoxChanged(inputAttribute, pValue, {checked:true}, true, idx)"
              [disabled]="( !(pValue.canSelect) || (pValue.disabled ||  pValue.group.endsWith('_NA')))">
              <span>+ Add</span></button>
          </div>
          <mat-divider *ngIf="!pValue.selected"></mat-divider>
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-container>
  <h5 class="align-center-actions"
    *ngIf="inputAttribute.possibleValues.length === inputAttribute.selectedTables.length">
    All available tables selected.
  </h5>
</div>
